(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ara-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FALLBACK_JOIN_COLOR = '#FEF1F7';
    var JOIN_VARIABLE = '--female-astrology-footer-join';
    var COLOR_VARIABLES = [
      '--ara-section-bg',
      '--section-background',
      '--section-bg',
      '--background-color'
    ];

    function isTransparentColor(value) {
      if (!value) return true;

      var color = value.replace(/\s+/g, '').toLowerCase();

      return (
        color === 'transparent' ||
        color === 'rgba(0,0,0,0)' ||
        color === 'rgba(0,0,0,0.0)' ||
        color === 'rgb(0 0 0/0)' ||
        color === 'rgb(0 0 0/0%)'
      );
    }

    function isValidColor(value) {
      if (!value) return false;

      var cleanValue = value.trim();

      if (!cleanValue || cleanValue.indexOf('var(') === 0) return false;

      if (/^\d+\s*,\s*\d+\s*,\s*\d+$/.test(cleanValue)) {
        return true;
      }

      return Boolean(
        window.CSS &&
        CSS.supports &&
        CSS.supports('color', cleanValue)
      );
    }

    function normalizeColor(value) {
      if (!isValidColor(value)) return '';

      var cleanValue = value.trim();

      if (/^\d+\s*,\s*\d+\s*,\s*\d+$/.test(cleanValue)) {
        return 'rgb(' + cleanValue + ')';
      }

      return cleanValue;
    }

    function isVisible(element) {
      if (!element || element.nodeType !== 1) return false;

      var style = window.getComputedStyle(element);
      var rect = element.getBoundingClientRect();

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number(style.opacity || 1) !== 0 &&
        rect.width > 0 &&
        rect.height > 0
      );
    }

    function findPreviousVisibleSection(footerSection) {
      var element = footerSection.previousElementSibling;

      while (element) {
        if (isVisible(element)) return element;
        element = element.previousElementSibling;
      }

      return null;
    }

    function readExplicitJoinColor(footerSection, previousSection) {
      var elements = [
        previousSection,
        previousSection ? previousSection.firstElementChild : null,
        document.body,
        document.documentElement,
        footerSection
      ];

      for (var index = 0; index < elements.length; index += 1) {
        var element = elements[index];

        if (!element) continue;

        var value = normalizeColor(
          window.getComputedStyle(element).getPropertyValue(JOIN_VARIABLE)
        );

        if (value) return value;
      }

      return '';
    }

    function readSolidBackground(element) {
      if (!element || !isVisible(element)) return '';

      var style = window.getComputedStyle(element);

      if (style.backgroundImage && style.backgroundImage !== 'none') {
        return '';
      }

      for (var index = 0; index < COLOR_VARIABLES.length; index += 1) {
        var customColor = normalizeColor(
          style.getPropertyValue(COLOR_VARIABLES[index])
        );

        if (customColor && !isTransparentColor(customColor)) {
          return customColor;
        }
      }

      if (!isTransparentColor(style.backgroundColor)) {
        return style.backgroundColor;
      }

      return '';
    }

    function findSolidBoundaryBackground(section) {
      if (!section) return '';

      var sectionStyle = window.getComputedStyle(section);

      if (sectionStyle.backgroundImage && sectionStyle.backgroundImage !== 'none') {
        return '';
      }

      var sectionRect = section.getBoundingClientRect();
      var minimumWidth = Math.max(1, sectionRect.width * 0.45);
      var candidates = [section].concat(
        Array.prototype.slice.call(section.querySelectorAll('*'))
      );

      candidates = candidates.filter(function (element) {
        if (!isVisible(element)) return false;

        var rect = element.getBoundingClientRect();
        var reachesBottom = rect.bottom >= sectionRect.bottom - 4;
        var coversEnoughWidth = rect.width >= minimumWidth;

        return reachesBottom && coversEnoughWidth;
      });

      for (var index = candidates.length - 1; index >= 0; index -= 1) {
        var background = readSolidBackground(candidates[index]);

        if (background) return background;
      }

      return readSolidBackground(section);
    }

    function updateFooterJoin(footer) {
      if (!footer) return;

      var footerSection = footer.closest('.shopify-section') || footer.parentElement;

      if (!footerSection) return;

      footerSection.style.removeProperty(JOIN_VARIABLE);

      var previousSection = findPreviousVisibleSection(footerSection);
      var explicitJoinColor = readExplicitJoinColor(footerSection, previousSection);
      var solidSectionColor = findSolidBoundaryBackground(previousSection);
      var joinColor = explicitJoinColor || solidSectionColor || FALLBACK_JOIN_COLOR;

      footerSection.style.setProperty(JOIN_VARIABLE, joinColor);
    }

    function updateAllFooters() {
      document.querySelectorAll('.ara-footer').forEach(function (footer) {
        updateFooterJoin(footer);
      });
    }

    function scheduleUpdate() {
    return; // Temporary Safari performance test
      window.requestAnimationFrame(updateAllFooters);
      window.setTimeout(updateAllFooters, 100);
      window.setTimeout(updateAllFooters, 500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleUpdate);
    } else {
      scheduleUpdate();
    }

    window.addEventListener('load', scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);

    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('shopify:section:reorder', scheduleUpdate);
    document.addEventListener('shopify:section:select', scheduleUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-horoscope-yearly"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getRoot(scope) {
      if (!scope) return null;

      if (scope.matches && scope.matches('.ara-zodiac-yearly')) {
        return scope;
      }

      if (scope.querySelector) {
        return scope.querySelector('.ara-zodiac-yearly');
      }

      return null;
    }

    function applyPageSkin(root) {
      if (!root || root.getAttribute('data-zodiac-filtered') !== 'true') return;

      document.documentElement.classList.add('ara-zodiac-yearly-page');
      document.body.classList.add('ara-zodiac-yearly-page');

      var styles = window.getComputedStyle(root);
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      var pageColor = styles.getPropertyValue(
        isDesktop ? '--ara-page-bg-desktop' : '--ara-page-bg-mobile'
      ).trim();

      if (!pageColor) return;

      var targets = [
        document.body,
        document.getElementById('MainContent'),
        document.querySelector('.shopify-section-group-header-group'),
        document.querySelector('.section-header'),
        document.querySelector('.header-wrapper'),
        document.querySelector('header.header'),
        document.querySelector('.shopify-section-group-footer-group'),
        document.querySelector('footer.ara-footer'),
        document.querySelector('footer.footer')
      ];

      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      var footerGroup = document.querySelector('.shopify-section-group-footer-group');

      if (headerGroup) {
        targets = targets.concat(Array.prototype.slice.call(headerGroup.querySelectorAll('.shopify-section, .gradient')));
      }

      if (footerGroup) {
        targets = targets.concat(Array.prototype.slice.call(footerGroup.querySelectorAll('.shopify-section, .gradient, footer')));
      }

      targets.forEach(function (target) {
        if (!target) return;

        target.style.setProperty('background-color', pageColor, 'important');
        target.style.setProperty('background-image', 'none', 'important');
        target.style.setProperty('--female-astrology-footer-join', pageColor);
      });
    }

    function initYearNavigation(root) {
      var yearNav = root.querySelector('.horoscope-year-nav');
      if (!yearNav || yearNav.getAttribute('data-ara-ready') === 'true') return;

      yearNav.setAttribute('data-ara-ready', 'true');

      var tabs = Array.prototype.slice.call(
        yearNav.querySelectorAll('.horoscope-year-nav__tab')
      );
      var contentContainer = root.querySelector('#horoscope-content');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var selectedYear = tab.getAttribute('data-year');

          tabs.forEach(function (item) {
            item.classList.toggle(
              'horoscope-year-nav__tab--active',
              item === tab
            );
          });

          if (!contentContainer) return;

          var foundArticle = false;
          var articles = contentContainer.querySelectorAll('.horoscope-article');
         
          articles.forEach(function (article) {
            var isMatch =
              article.getAttribute('data-article-year') === selectedYear;

            article.style.display = isMatch ? 'flex' : 'none';
            article.classList.toggle('horoscope-article--active', isMatch);

            if (isMatch) foundArticle = true;
          });

       
    var emptyMessage = contentContainer.querySelector('.horoscope-filter-empty');

    if (foundArticle) {
      if (emptyMessage) {
        emptyMessage.remove();
      }
    } else if (!emptyMessage) {
      emptyMessage = document.createElement('div');
      emptyMessage.className = 'horoscope-empty horoscope-filter-empty';

      var message = document.createElement('p');
      message.textContent = 'No horoscope available for this year yet.';

      emptyMessage.appendChild(message);
      contentContainer.appendChild(emptyMessage);
    }

        });
      });

      var activeTab = yearNav.querySelector(
        '.horoscope-year-nav__tab--active'
      );

      if (activeTab) {
        activeTab.click();
      }
    }

    function initYearlyPurchaseForms(root) {
      root.querySelectorAll('.ara-zodiac-clear-add-form').forEach(function (form) {
        if (form.getAttribute('data-ara-ready') === 'true') return;

        form.setAttribute('data-ara-ready', 'true');

        form.addEventListener('submit', function (event) {
          event.preventDefault();

          var button = form.querySelector('button[type="submit"]');

          if (button) button.disabled = true;

          var idInput = form.querySelector('[name="id"]');
          var quantityInput = form.querySelector('[name="quantity"]');
          var properties = {};

          form.querySelectorAll('[name^="properties["]').forEach(function (input) {
            var key = input.name.replace('properties[', '').replace(']', '');
            properties[key] = input.value;
          });

          if (!idInput || !idInput.value) {
            if (button) button.disabled = false;
            return;
          }

          var item = {
            id: Number(idInput.value),
            quantity: quantityInput ? Number(quantityInput.value) : 1,
            properties: properties
          };

          fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(item)
              });
            })
            .then(function (response) {
              if (!response.ok) throw new Error('Unable to add yearly horoscope');
              window.location.href = '/checkout';
            })
            .catch(function () {
              if (button) button.disabled = false;
            });
        });
      });
    }

    function initRoot(root) {
      if (!root) return;

      applyPageSkin(root);
      initYearNavigation(root);
      initYearlyPurchaseForms(root);
    }

    function initAll(scope) {
      if (!scope) return;

      var directRoot = getRoot(scope);

      if (directRoot) {
        initRoot(directRoot);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll('.ara-zodiac-yearly').forEach(initRoot);
      }
    }

    function start() {
      initAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    window.addEventListener('load', start);
    window.addEventListener('resize', function () {
      document.querySelectorAll('.ara-zodiac-yearly').forEach(applyPageSkin);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-horoscope"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getRoot(scope) {
      if (!scope) return null;

      if (scope.matches && scope.matches('.ara-zodiac-monthly')) {
        return scope;
      }

      if (scope.querySelector) {
        return scope.querySelector('.ara-zodiac-monthly');
      }

      return null;
    }

    function applyPageSkin(root) {
      if (!root || root.getAttribute('data-zodiac-filtered') !== 'true') return;

      document.documentElement.classList.add('ara-zodiac-monthly-page');
      document.body.classList.add('ara-zodiac-monthly-page');

      var styles = window.getComputedStyle(root);
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      var pageColor = styles.getPropertyValue(
        isDesktop ? '--ara-page-bg-desktop' : '--ara-page-bg-mobile'
      ).trim();

      if (!pageColor) return;

      var targets = [
        document.body,
        document.getElementById('MainContent'),
        document.querySelector('.shopify-section-group-header-group'),
        document.querySelector('.section-header'),
        document.querySelector('.header-wrapper'),
        document.querySelector('header.header'),
        document.querySelector('.shopify-section-group-footer-group'),
        document.querySelector('footer.ara-footer'),
        document.querySelector('footer.footer')
      ];

      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      var footerGroup = document.querySelector('.shopify-section-group-footer-group');

      if (headerGroup) {
        targets = targets.concat(Array.prototype.slice.call(headerGroup.querySelectorAll('.shopify-section, .gradient')));
      }

      if (footerGroup) {
        targets = targets.concat(Array.prototype.slice.call(footerGroup.querySelectorAll('.shopify-section, .gradient, footer')));
      }

      targets.forEach(function (target) {
        if (!target) return;

        target.style.setProperty('background-color', pageColor, 'important');
        target.style.setProperty('background-image', 'none', 'important');
        target.style.setProperty('--female-astrology-footer-join', pageColor);
      });
    }

    function initMonthNavigation(root) {
      var monthNav = root.querySelector('.horoscope-month-nav');
      if (!monthNav || monthNav.getAttribute('data-ara-ready') === 'true') return;

      monthNav.setAttribute('data-ara-ready', 'true');

      var tabs = Array.prototype.slice.call(
        monthNav.querySelectorAll('.horoscope-month-nav__tab')
      );
      var contentContainer = root.querySelector('#horoscope-content');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var selectedMonth = tab.getAttribute('data-month');

          tabs.forEach(function (item) {
            item.classList.toggle(
              'horoscope-month-nav__tab--active',
              item === tab
            );
          });

          if (!contentContainer) return;

         
      var foundArticle = false;
      var articles = contentContainer.querySelectorAll('.horoscope-article');
      var emptyMessage = contentContainer.querySelector('.horoscope-filter-empty');

      articles.forEach(function (article) {
        var isMatch =
          article.getAttribute('data-article-month') === selectedMonth;

        article.style.display = isMatch ? 'flex' : 'none';
        article.classList.toggle('horoscope-article--active', isMatch);

        if (isMatch) foundArticle = true;
      });

      if (foundArticle) {
        if (emptyMessage) {
          emptyMessage.remove();
        }
      } else {
        if (!emptyMessage) {
          emptyMessage = document.createElement('div');
          emptyMessage.className = 'horoscope-empty horoscope-filter-empty';

          var message = document.createElement('p');
          message.textContent = 'No horoscope available for this month yet.';

          emptyMessage.appendChild(message);
          contentContainer.appendChild(emptyMessage);
        }
      }


        });
      });

      var activeTab = monthNav.querySelector(
        '.horoscope-month-nav__tab--active'
      );

      if (activeTab) {
        activeTab.click();
      }
    }

    function initSubscriptionForms(root) {
      root.querySelectorAll('.ara-zodiac-clear-add-form').forEach(function (form) {
        if (form.getAttribute('data-ara-ready') === 'true') return;

        form.setAttribute('data-ara-ready', 'true');

        form.addEventListener('submit', function (event) {
          event.preventDefault();

          var button = form.querySelector('button[type="submit"]');

          if (button) button.disabled = true;

          var idInput = form.querySelector('[name="id"]');
          var quantityInput = form.querySelector('[name="quantity"]');
          var sellingPlanInput = form.querySelector('[name="selling_plan"]');
          var properties = {};

          form.querySelectorAll('[name^="properties["]').forEach(function (input) {
            var key = input.name.replace('properties[', '').replace(']', '');
            properties[key] = input.value;
          });

          if (!idInput || !idInput.value) {
            if (button) button.disabled = false;
            return;
          }

          var item = {
            id: Number(idInput.value),
            quantity: quantityInput ? Number(quantityInput.value) : 1,
            properties: properties
          };

          if (sellingPlanInput && sellingPlanInput.value) {
            item.selling_plan = Number(sellingPlanInput.value);
          }

          fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(item)
              });
            })
            .then(function (response) {
              if (!response.ok) throw new Error('Unable to add subscription');
              window.location.href = '/checkout';
            })
            .catch(function () {
              if (button) button.disabled = false;
            });
        });
      });
    }

    function initRoot(root) {
      if (!root) return;

      applyPageSkin(root);
      initMonthNavigation(root);
      initSubscriptionForms(root);
    }

    function initAll(scope) {
      if (!scope) return;

      var directRoot = getRoot(scope);

      if (directRoot) {
        initRoot(directRoot);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll('.ara-zodiac-monthly').forEach(initRoot);
      }
    }

    function start() {
      initAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    window.addEventListener('load', start);
    window.addEventListener('resize', function () {
      document.querySelectorAll('.ara-zodiac-monthly').forEach(applyPageSkin);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-monthly-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAraPremiumMonthly(section) {
      if (!section || section.getAttribute('data-ara-tabs-initialized') === 'true') return;

      section.setAttribute('data-ara-tabs-initialized', 'true');

      var tabs = Array.prototype.slice.call(
        section.querySelectorAll('.ara-premium-monthly__tab')
      );
      var panels = Array.prototype.slice.call(
        section.querySelectorAll('.ara-premium-monthly__panel')
      );

      if (!tabs.length || !panels.length) return;

      function activateSign(sign, moveFocus) {
        tabs.forEach(function (tab) {
          var isActive = tab.getAttribute('data-ara-sign') === sign;

          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');

          if (isActive && moveFocus) {
            tab.focus();
          }
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-ara-panel') === sign;

          panel.classList.toggle('is-hidden', !isActive);
          panel.hidden = !isActive;
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateSign(tab.getAttribute('data-ara-sign'), false);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;

          if (event.key === 'ArrowRight') {
            nextIndex = index === tabs.length - 1 ? 0 : index + 1;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = index === 0 ? tabs.length - 1 : index - 1;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          activateSign(tabs[nextIndex].getAttribute('data-ara-sign'), true);
        });
      });

      section.querySelectorAll('.ara-premium-monthly__toc a').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var selector = link.getAttribute('href');

          if (!selector || selector.charAt(0) !== '#') return;

          var target = section.querySelector(selector);

          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
      });

      var activeTab = section.querySelector('.ara-premium-monthly__tab.is-active');
      var initialTab = activeTab || tabs[0];

      if (initialTab) {
        activateSign(initialTab.getAttribute('data-ara-sign'), false);
      }
    }

    function initAllAraPremiumMonthly(scope) {
      if (!scope) return;

      if (
        scope.nodeType === 1 &&
        scope.classList &&
        scope.classList.contains('ara-premium-monthly')
      ) {
        initAraPremiumMonthly(scope);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll('.ara-premium-monthly').forEach(function (section) {
          initAraPremiumMonthly(section);
        });
      }
    }

    function startAraPremiumMonthly() {
      initAllAraPremiumMonthly(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startAraPremiumMonthly);
    } else {
      startAraPremiumMonthly();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAllAraPremiumMonthly(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
